import {
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';

import { Subject } from 'rxjs';

@Component({
    selector: 'app-display-panel-box',
    templateUrl: './display-panel-box.component.html',
    styleUrls: ['./display-panel-box.component.scss']
})
export class DisplayPanelBoxComponent implements OnDestroy {
    @Input() secondary: boolean;
    @ViewChild('panel', { static: true }) panel: ElementRef;

    private changeSubject = new Subject<Event>();
    panelStyle: any; // use an object to avoid expression change error

    minHeight = 500;

    constructor() {
    }

    get panelHeight() {

        if (!!this.panelStyle) {
            const height = this.panel.nativeElement.clientHeight - 40 + 'px';
            this.panelStyle = { ...this.panelStyle, height };
        } else {
            this.panelStyle = { width: '100%', height: `${this.minHeight}px` };
        }

        return this.panelStyle;
    }

    ngOnDestroy() {
        this.changeSubject.unsubscribe();
    }

}
